import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
  OnChanges,
  forwardRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { CcyPairPromiseLookupService } from "shared/cubiq-services";
import { CurrencyPairImpl } from "shared/cubiq-model-multi-asset";
import { RateSpinnerComponent } from "shared/base-components/rate-spinner.component";

export const SPINNER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ICPriceSpinnerComponent),
  multi: true,
};

import { LoggerService } from "@bfx/logger";
import { BfxFieldNumberDirective } from "../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../shared/base-components/bfx-input";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
} from "../../shared/base-components/number-spinner.component";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "ic-price-spinner",
  templateUrl: "../../shared/base-components/html/number-spinner.html",
  providers: [SPINNER_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ICPriceSpinnerComponent extends RateSpinnerComponent implements OnChanges {
  /**********************************************************/
  /* Input parameter config */

  @Input() useBMPrecision: boolean = false;

  @Input() useMidPrecision: boolean = false;

  /**********************************************************/

  @Input() dead?: boolean = false;

  @Input() deadNeg?: boolean = false;

  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPairService: CcyPairPromiseLookupService,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPairService);
  }

  @Input() set inverted(value: boolean) {
    this.isInverted = value;
  }
  get inverted(): boolean {
    return this.isInverted;
  }

  protected override getMaxPrecision(pair: CurrencyPairImpl): number {
    if (!this.useBMPrecision) {
      return super.getMaxPrecision(pair);
    }
    let digits = 4;
    if (this.isInverted) {
      digits = this.useMidPrecision
        ? pair.bmSpotInvPrecision + pair.additionalMidRoundingPrecision
        : pair.bmSpotInvPrecision;
    } else {
      digits = this.useMidPrecision
        ? pair.bmSpotPrecision + pair.additionalMidRoundingPrecision
        : pair.bmSpotPrecision;
    }
    if (digits == null || isNaN(digits)) {
      logger.out.warn(
        `Misconfigured pair - got null decimals for ${pair.base + pair.nonBase} - fwd = ${
          this.isFwd
        }, invert=${this.isInverted}`,
      );
      digits = 0;
    }
    return digits;
  }

  /**
   * map dead/deadNeg used in Gamma processing to a fieldState
   */
  protected override updateInputClasses(): void {
    super.updateInputClasses();
    if (this.dead && !this.deadNeg) {
      this.fieldState = "disabled";
    }
    if (this.deadNeg) {
      this.fieldState = "invalid";
    }
  }
}
